

import { firestore } from '@/firebase';
import { ROOT_ACTIONS } from '@/store/actions';
import { USER_GETTERS } from '@/store/user/getters';
import { Phase } from '@/types';
import { collection, getDoc, getDocs, orderBy, query, where, doc, addDoc, FieldPath, deleteDoc, Timestamp, updateDoc } from 'firebase/firestore';
import { Component, Prop, Vue, Watch, } from 'vue-property-decorator';


@Component
export default class ProgramScreenCastsCard extends Vue {
    @Prop({ required: true }) userId!: string;
    @Prop({ required: true }) phases!: Phase[];

    screencasts = [] as any[];


    get currentUser() {
        return this.$store.getters[USER_GETTERS.ACTING_USER];
    }

    open = false;

    async fetchScreenCasts() {
        this.screencasts = [];
        const result = await getDocs(query(collection(firestore, 'content-assignments'), where('user', '==', this.userId)));
        for (const assignment of result.docs) {
            if (!assignment.data().contentId) {
                continue;
            }
            const content = await getDoc(doc(firestore, 'content-items', assignment.data().contentId));
            const requestedBy = assignment.data().requestedBy;
            this.screencasts.push({
                id: assignment.id,
                title: content.data()!.title,
                completed: assignment.data().completed,
                selfAssigned: requestedBy === this.userId,
            })
        }
    }

    async mounted() {
        await this.fetchScreenCasts();
    }

    addContentAssignmentDialog = false;

    content = [] as any[];
    selectedContent = '';

    @Watch('addContentAssignmentDialog')
    async onOpenAddContentAssignmentDialog() {
        if (this.addContentAssignmentDialog) {
            const docs = await getDocs(query(collection(firestore, 'content-items')));
            this.content = docs.docs.map(doc => {
                return {
                    id: doc.id,
                    title: doc.data().title,
                    language: doc.data().language,
                }
            });
        }
    }

    async addContentAssignment() {
        if (!this.selectedContent) {
            this.$store.dispatch(ROOT_ACTIONS.TOGGLE_NOTIFICATION, {
                color: 'error',
                text: 'Please select a screencast',
            })
            return;
        }
        
        // Get hourValue from selected content
        let hourValue = 1; // default
        try {
            const contentDoc = await getDoc(doc(firestore, 'content-items', this.selectedContent));
            if (contentDoc.exists()) {
                hourValue = contentDoc.data()!.hourValue || 1;
            }
        } catch (error) {
            console.warn('Could not fetch hourValue, using default', error);
        }

        // Create content assignment without phase/activity linking
        await addDoc(collection(firestore, 'content-assignments'), {
            user: this.userId,
            contentId: this.selectedContent,
            completed: false,
            requestedBy: this.currentUser.id,
            autoCompleteHours: true,
            hourValue: hourValue,
            legacy: false,
        });
        
        this.addContentAssignmentDialog = false;
        this.$emit('refresh');
    }

    deleteScreencast = async (id: string) => {
        await deleteDoc(doc(firestore, 'content-assignments', id));
        this.$emit('refresh');
    }
}


